import { useNavigate } from '@solidjs/router';
import { createSignal, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { ErrorCatcher } from '../../tools/error-catcher';
import { Section } from '../../grid-system/section/section';
import { Column } from '../../grid-system/column/column';
import { SearchAutocomplete } from '../search/search-autocomplete';
import { buildSearchPageUrl } from '../search/search-shared';

/* `atos/search-widget` (Figma 1443:13374 / 1443:13694), used on e.g. the 404 page: a
   brand-wash card with a heading, a line of copy and the search field with suggestions.
   Enter without a pick hands the query to the search page. */
export const SearchWidget = () => {
    const { localize, searchPage } = useContext(AppContext);

    if (!searchPage.url || searchPage.url === '') {
        return <div>please check if search page is set in Site settings - General options</div>;
    }

    const navigate = useNavigate();
    const [query, setQuery] = createSignal('');

    const submit = (value: string) => {
        if (!value.trim()) {
            return;
        }

        navigate(buildSearchPageUrl(searchPage.url, value));
    };

    return (
        <ErrorCatcher componentName="SearchWidget">
            <Section widthType="bgFull" isLayoutSection={true}>
                <Column>
                    <div class="flex flex-col gap-cvi-8 rounded-cvi-xl bg-cvi-bg-brand-gradient-start p-cvi-8">
                        <div class="flex flex-col gap-cvi-4">
                            <h3 class="m-0 heading-xl font-cvi-medium text-cvi-fg-default">
                                {localize('atos-search-tool', 'Atos search tool')}
                            </h3>
                            <p class="m-0 body-md font-cvi-regular text-cvi-fg-default">
                                {localize('did-you-look-for-something-specific', 'Did you look for something specific? Please use our search tool and try again.')}
                            </p>
                        </div>

                        <SearchAutocomplete
                            id="search-widget"
                            class="max-w-cvi-search-field"
                            value={query()}
                            onInput={setQuery}
                            onSubmit={submit}
                            placeholder={localize('search', 'Search')}
                        />
                    </div>
                </Column>
            </Section>
        </ErrorCatcher>
    );
};
